import React, { useEffect, useState, useRef } from "react";
import {
  Tab,
  Tabs,
  Box,
  Button,
  Typography,
  Divider,
  Tooltip,
  FormControlLabel,
  Switch,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import axios from "axios";
import { History } from "./History";
import { toast } from "react-toastify";
import { PatientAssessmentForm } from "./anathesia/PreAnathesiaAssessment";
import dayjs from "dayjs";
import { PostAnathesia } from "./anathesia/PostAnathesia";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { fetchProjectProfileData } from "../../../../redux/reducers/projectProfileSlice";
import { Examination } from "./Examination";
import Treatment from "./treatment";
import { Investigation } from "./Investegation";
import PreSurgical from "./surgical/PreSurgical";
import Preoperation from "./surgical/PreOperation";
import OtRoomAnaesthesiaMonitoring from "./anathesia/OtRoomAnaesthesiaMonitoring";
import OT_Nurse from "./ot-nurse";
import TreamentChart from "./treatment_Chart/TreamentChart";

import VitalAndIOPChart from "./vital-iop-chart";
import CallToDoctor from "./CallToDoctor";
import OT from "./ot";
import PostOperation from "./surgical/PostOperation";
import { ADMISSION_TYPE } from "../../../../enums";
import { useLocation, useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import DailyProgressNotes from "./DailyProgressNotes";
import Chemotherapy from "./Chemotherapy";
import ChemotherapyConsent from "./ChemotherapyConsent";
import { log } from "console";
import socket from "../../../../socket";

// Define a FallbackComponent to use when a component is not available
const FallbackComponent = () => (
  <Box p={2}>
    <Typography>Component not available for this admission type</Typography>
  </Box>
);

const tabComponents: any = [
  { label: "History", component: History, formName: "History" },
  { label: "Examination", component: Examination, formName: "Examination" },
  {
    label: "Investigation",
    component: Investigation,
    formName: "Investegation",
  },
  { label: "Treatment", component: Treatment, formName: "Treatment" },
  {
    label: "Anesthesia",
    subTabs: [
      {
        label: "Pre Anesthesia Assessment",
        component: PatientAssessmentForm,
        formName: "Pre_Anesthesia_Assessment",
      },
      {
        label: "OT Room Anaesthesia Monitoring",
        component: OtRoomAnaesthesiaMonitoring,
        formName: "ot_room_anaesthesia_monitoring",
      },
      {
        label: "Post Anesthesia Monitoring",
        component: PostAnathesia,
        formName: "Post_Anathesia",
      },
    ],
  },
  {
    label: "Surgical",
    subTabs: [
      {
        label: "Pre_Surgical",
        component: PreSurgical,
        formName: "Pre_Surgical",
      },
      {
        label: "Per_Operation",
        component: Preoperation,
        formName: "Per_Operation",
      },
      {
        label: "Post_Operation",
        component: PostOperation,
        formName: "Post_Operation",
      },
    ],
  },
  { label: "OT_Nurse", component: OT_Nurse, formName: "OT_Nurse" },
  {
    label: "Treatment_Chart",
    component: TreamentChart,
    formName: "Treatment_Chart",
  },
  {
    label: "DPN",
    component: DailyProgressNotes,
    formName: "Daily_Progress_Notes",
  },
  {
    label: "Vital_IOP_Chart",
    component: VitalAndIOPChart,
    formName: "Vital_And_IOP_Chart",
  },
  {
    label: "Chemotherapy",
    component: Chemotherapy,
    formName: "Chemotherapy",
  },
  {
    label: "Chemotherapy_Consent",
    component: ChemotherapyConsent,
    formName: "Chemotherapy_Consent",
  },
  {
    label: "Call_To_Doctor",
    component: CallToDoctor,
    formName: "Call_To_Doctor",
  },
  { label: "OT", component: OT, formName: "OT" },
];

const calculateAge = (dob: any) => {
  if (!dob) return "";
  const birthDate = dayjs(dob);
  const today = dayjs();

  const years = today.diff(birthDate, "year");
  const months = today.diff(birthDate.add(years, "year"), "month");
  const days = today.diff(
    birthDate.add(years, "year").add(months, "month"),
    "day"
  );

  return `${years} Y, ${months} M, ${days} D`;
};

// Improved safeRenderComponent function with better error handling
const safeRenderComponent = (componentInfo: any) => {
  if (!componentInfo) {
    return FallbackComponent;
  }

  if (!componentInfo.component) {
    console.warn(
      `Component not found for tab: ${componentInfo?.label || "unknown"}`
    );
    return FallbackComponent;
  }

  return componentInfo.component;
};

const TabbedForm: React.FC = () => {
  const [activeTab, setActiveTab] = useState<number>(0);
  const [activeSubTab, setActiveSubTab] = useState<number>(0);
  const [tabData, setTabData] = useState<any>({});
  const [historyData, setHistoryData] = useState<any>({});
  const [fetchedData, setFetchedData] = useState<any>({});
  // const [formId, setFormId] = useState<any>('');
  // const [ctdresponseData, setCtdresponseData] = useState<any>();
  const [age, setAge] = useState<any>();
  const profile = useSelector((state: any) => state?.profileSlice?.profile);
  const dispatch = useDispatch();
  const [knownData, setKnownData] = useState<any>();
  const navigate = useNavigate();
  const location = useLocation();
  const { otherTabsData } = location.state || {};
  const [loading, setLoading] = useState<boolean>(false);
  const [opdData, setOpdData] = useState<any>();
  const saveAndNext: any = useRef(null);
  const back: any = useRef(null);
  const save: any = useRef(null);
  const saveAndExit: any = useRef(null);
  const [admissionType, setAdmissionType] = useState<string>(
    otherTabsData?.admissionType || "Medical"
  );
  const [filteredTabComponents, setFilteredTabComponents] =
    useState<any>(tabComponents);
  const [openDialog, setOpenDialog] = useState(false);
  const [newAdmissionType, setNewAdmissionType] = useState<string>("");
  const [searchId, setSearchId] = useState<any>();
  const [patientId, setPatientId] = useState<any>();
  const [isSwitchDisabled, setIsSwitchDisabled] = useState<boolean>(false);
  // const [callToDoctorResponse, setCallToDoctor] = useState<any>(false);

  const handleSwitchChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setOpenDialog(true);
    const newAdmissionType = event.target.checked ? "Surgical" : "Medical";
    setNewAdmissionType(newAdmissionType);
  };

  const handleConfirmChange = async () => {
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_IPD_API_URL}/ipd-admission/updateAdmissionType/${otherTabsData?._id}`,
        {
          admissionType: newAdmissionType,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.isSuccess) {
        setAdmissionType(newAdmissionType);
        toast.success("Admission type updated successfully!");
        filterTabsBasedOnAdmissionType(newAdmissionType);
        // Reset active tab indexes to prevent component not found errors
        setActiveTab(0);
        setActiveSubTab(0);
        setOpenDialog(false);
      } else if (!response?.data?.isSuccess) {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      toast.error("Failed to update admission type.");
      console.error("Error updating admission type:", error);
    }
  };

  const handleCancelChange = () => {
    setOpenDialog(false);
  };

  useEffect(() => {
    const handleKeyDown = (event: any) => {
      if (event.key === "Enter" && event.shiftKey) {
        event.preventDefault();
        saveAndNext.current?.click();
      } else if (event.key === "Backspace" && event.ctrlKey) {
        event.preventDefault();
        back.current?.click();
      } else if (event.key === "s" && event.ctrlKey) {
        event.preventDefault();
        save.current?.click();
      } else if (event.which == 27) {
        event.preventDefault();
        saveAndExit.current?.click();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (otherTabsData) {
      getDataById();
      setAge(calculateAge(otherTabsData?.patientData?.dob));
      setPatientId(otherTabsData?.patientData?._id);
      setSearchId(otherTabsData?._id);
      setAdmissionType(otherTabsData?.admissionType || "Medical");
    }
  }, [otherTabsData]);

  const filterTabsBasedOnAdmissionType = (admissionType: string) => {
    const surgicalOnly = ["Surgical", "Anesthesia", "OT_Nurse", "OT"];
    const filteredTabs = tabComponents.filter((tab: any) => {
      if (tab?.label === "Chemotherapy" || tab?.label === "Chemotherapy_Consent") {
        return admissionType === "Chemotherapy";
      }
      if (admissionType === "Medical") {
        return !surgicalOnly.includes(tab?.label);
      }
      if (admissionType === "Chemotherapy") {
        return !surgicalOnly.includes(tab?.label) && tab?.label !== "Call_To_Doctor";
      }
      return true;
    });
    setFilteredTabComponents(filteredTabs);

    // Reset active tab indexes to prevent component not found errors
    setActiveTab(0);
    setActiveSubTab(0);
  };

  useEffect(() => {
    filterTabsBasedOnAdmissionType(admissionType);
  }, [admissionType]);

  const getDataById = async () => {
    try {
      // Construct the base URL with patientId
      let url = `${process.env.REACT_APP_OPD_API_URL}/opd-prescription/getLastByPatientId/${otherTabsData?.patientData?._id}`;

      const appointmentId =
        otherTabsData?.appointmentId?._id || otherTabsData?.appointmentId;
      if (appointmentId) {
        url += `?appointmentId=${appointmentId}`;
      }

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      const fetchedData = response?.data?.data?.[0];
      setOpdData(fetchedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    dispatch(fetchProjectProfileData() as any);
  }, [dispatch]);

  const fetchFormData = async (formName: string) => {
    if (!formName || !otherTabsData?._id) {
      console.warn("Missing required data for fetching form data");
      return;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_IPD_API_URL}/ipd-form-data/getFormDataBySearchId/${otherTabsData?._id}?formName=${formName}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const formData = response?.data?.data?.formData ?? {};
      setFetchedData(formData);
      setTabData((prevData: any) => ({
        ...prevData,
        [activeTab]: formData,
      }));
    } catch (error) {
      toast.error("Failed to fetch form data.");
    }
  };

  const fetchknownDataForHeader = async () => {
    if (!otherTabsData?.patientData?._id) return;

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_IPD_API_URL}/patient-general-info/getPatientGenerlInfo/${otherTabsData?.patientData?._id}`,
        {
          headers: {
            accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setKnownData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching patient general info:", error);
    }
  };

  useEffect(() => {
    // Safety check to make sure the activeTab exists
    if (activeTab >= filteredTabComponents.length) {
      setActiveTab(0);
      setActiveSubTab(0);
      return;
    }

    const currentTab = filteredTabComponents[activeTab];

    // Safety check for subtabs
    if (currentTab?.subTabs && activeSubTab >= currentTab.subTabs.length) {
      setActiveSubTab(0);
      return;
    }

    const formName = currentTab?.subTabs
      ? currentTab.subTabs[activeSubTab]?.formName
      : currentTab?.formName;

    if (formName) {
      fetchFormData(formName);
    }

    fetchknownDataForHeader();
  }, [activeTab, activeSubTab, filteredTabComponents, socket]);

  const handleTabChangeWithData = (data: any) => {
    setTabData((prevData: any) => ({
      ...prevData,
      [activeTab]: data,
    }));
  };

  const handlehistorydata = (data: any) => {
    setHistoryData((prevData: any) => ({
      ...prevData,
      [activeTab]: data,
    }));
  };

  useEffect(() => {
    setAge(calculateAge(otherTabsData?.patientData?.dob));
  }, [otherTabsData]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tab = queryParams.get("tab");

    if (tab) {
      const activeTabIndex = filteredTabComponents.findIndex(
        (t: any) => t.label === tab
      );
      if (activeTabIndex !== -1) {
        setActiveTab(activeTabIndex);
        setActiveSubTab(0);
      }
    }
  }, [location.search, filteredTabComponents]);

  const handleNext = async () => {
    setLoading(true);
    await handleSave(false);

    const currentTab = filteredTabComponents[activeTab];

    if (currentTab?.subTabs) {
      if (activeSubTab < currentTab.subTabs.length - 1) {
        handleSubTabChange(activeSubTab + 1);
      } else if (activeTab < filteredTabComponents.length - 1) {
        handleTabChange(activeTab + 1);
        setActiveSubTab(0);
      }
    } else if (activeTab < filteredTabComponents.length - 1) {
      handleTabChange(activeTab + 1);
      setActiveSubTab(0);
    }

    setLoading(false);
  };

  const handleBack = () => {
    if (activeTab === 0) {
      navigate("/ipd-dashboard");
    } else {
      handleTabChange(activeTab - 1);
      setActiveSubTab(0);
    }
  };

  const handleSaveObsData = async (patientData: any) => {
    if (!otherTabsData?.patientData?._id || !patientData) return null;

    const url = `${process.env.REACT_APP_IPD_API_URL}/patient-general-info/updatePatientGenerlInfo`;
    const headers = {
      Accept: "*/*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    };
    const body = JSON.stringify({
      patientId: otherTabsData?.patientData?._id,
      knownAllergies: patientData.knownAllergies,
      knownDeseise: patientData.knownDeseise,
      pregnancyInfo: patientData.ObsHistory,
    });

    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: headers,
        body: body,
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Request failed", error);
      return null;
    }
  };

  const handleSave = async (
    shouldClose?: boolean,
    searchId?: any,
    patientId?: any
  ) => {
    setLoading(true);

    try {
      // Save observation data if we're on the first tab (History)
      if (activeTab === 0 && historyData[0]) {
        await handleSaveObsData(historyData[0]);
      }

      // Get the data to save from the current tab
      let dataToSave = tabData[activeTab];

      // Recover nested formData shape if a full API document was stored earlier
      if (dataToSave?.formData && typeof dataToSave.formData === 'object') {
        dataToSave = dataToSave.formData;
      }

      if (!dataToSave) {
        setLoading(false);
        return;
      }

      // Safety check for current tab
      if (activeTab >= filteredTabComponents.length) {
        console.error("Invalid active tab index");
        setLoading(false);
        return;
      }

      const currentTab = filteredTabComponents[activeTab];

      // Safety check for subtabs
      if (currentTab?.subTabs && activeSubTab >= currentTab.subTabs.length) {
        console.error("Invalid active subtab index");
        setLoading(false);
        return;
      }

      // Get the form name based on current tab/subtab
      const formName = currentTab?.subTabs
        ? currentTab.subTabs[activeSubTab]?.formName
        : currentTab?.formName;

      if (!formName) {
        console.error("Form name is undefined");
        setLoading(false);
        return;
      }

      if (formName === "Daily_Progress_Notes") {
        if (shouldClose) {
          navigate("/ipd-dashboard");
        }
        return null;
      }

      if (formName === "Vital_And_IOP_Chart") {
        if (shouldClose) {
          navigate("/ipd-dashboard");
        }
        return null;
      }

      // if (formName === "Daily_Progress_Notes" ) {
      //   navigate('/ipd-dashboard');
      // }

      const response = await axios.post(
        `${process.env.REACT_APP_IPD_API_URL}/ipd-form-data/CreateFormData`,
        {
          formName,
          formData: dataToSave,
          searchId: otherTabsData?._id || searchId,
          patientId: otherTabsData?.patientData?._id || patientId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (shouldClose) {
        navigate("/ipd-dashboard");
      }

      // console.log("Call_To_Doctor form submitted:", response.data.data);
      // if (response.data.data.formName === "Call_To_Doctor") {
        
        
      //   const arr = response.data?.data?.formData?.call_To_Doc;
      //   if (arr.length >= 0) {
      //    setFormId(response.data.data._id);
      //   }
      //   setCtdresponseData(arr?.at(-1) ?? null);
      // }
      toast.success(response?.data?.message);
    } catch (error) {
      console.error("Error saving data:", error);
      toast.error("Failed to save data");
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (newTab: number) => {
    // Safety check to prevent selecting invalid tabs
    if (newTab < 0 || newTab >= filteredTabComponents.length) {
      console.warn(`Invalid tab index: ${newTab}`);
      return;
    }

    setActiveTab(newTab);
    setActiveSubTab(0);

    const currentTab = filteredTabComponents[newTab];
    navigate(`?tab=${currentTab?.label || ""}`, { state: { otherTabsData } });
  };

  const handleSubTabChange = (newSubTab: number) => {
    // Safety check to prevent selecting invalid subtabs
    const currentTab = filteredTabComponents[activeTab];
    if (
      !currentTab?.subTabs ||
      newSubTab < 0 ||
      newSubTab >= currentTab.subTabs.length
    ) {
      console.warn(`Invalid subtab index: ${newSubTab}`);
      return;
    }

    setActiveSubTab(newSubTab);
  };

  useEffect(() => {
    // Check if the patient is discharged to disable the admission type switch
    const fetchFormDataForSwitch = async () => {
      if (!otherTabsData?._id) return;

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_IPD_API_URL}/ipd-form-data/getFormDataBySearchId/${otherTabsData?._id}?formName=DischargeForm`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        if (response?.data?.data?.formData) {
          setIsSwitchDisabled(true);
        }
      } catch (error) {
        console.error("Failed to fetch discharge form data:", error);
      }
    };

    fetchFormDataForSwitch();
  }, [otherTabsData]);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        backgroundColor: "#fff",
      }}
      tabIndex={0}
    >
      <Box
        sx={{
          width: "100%",
          height: { md: "75vh", sm: "100%", xs: "100%" },
          overflowY: "auto",
          "&::-webkit-scrollbar": {
            width: "5px",
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#888",
            borderRadius: "5px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "#555",
          },
        }}
      >
        <Box
          sx={{
            position: "sticky",
            top: 0,
            backgroundColor: "#fff",
            zIndex: 1000,
          }}
        >
          <Box sx={{ p: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={6} sm={4} md={2.5}>
                <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>
                  <span style={{ fontWeight: "600" }}> Known disease: </span>{" "}
                  {knownData?.knownDeseise || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={4} md={2}>
                <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>
                  <span style={{ fontWeight: "600" }}>Known Allergies: </span>{" "}
                  {knownData?.knownAllergies || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={4} md={2}>
                <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>
                  <span style={{ fontWeight: "600" }}> Doctor Name: </span>{" "}
                  {otherTabsData?.doctorName}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={4} md={1}>
                <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>
                  <span style={{ fontWeight: "600" }}>MRN: </span>{" "}
                  {otherTabsData?.patientData?.mrn}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={4} md={1}>
                <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>
                  <span style={{ fontWeight: "600" }}> P.Name: </span>{" "}
                  {otherTabsData?.patientData?.patientName}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={4} md={1}>
                <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>
                  <span style={{ fontWeight: "600" }}> Guardian : </span>{" "}
                  {otherTabsData?.patientData?.guardiansName}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={4} md={1.5}>
                <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>
                  <span style={{ fontWeight: "700" }}> Age: </span> {age}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={4} md={1}>
                <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>
                  <span style={{ fontWeight: "700" }}> weight: </span>{" "}
                  {otherTabsData?.weight
                    ? `${otherTabsData?.weight} KG`
                    : `${opdData?.weight || "-"} KG`}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={4} md={1}>
                <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>
                  <span style={{ fontWeight: "600" }}> Gender: </span>{" "}
                  {otherTabsData?.patientData?.gender}
                </Typography>
              </Grid>
            </Grid>
          </Box>
          {/* Only render tabs if there are filtered tabs to display */}
          {filteredTabComponents.length > 0 && (
            <Tabs
              value={Math.min(activeTab, filteredTabComponents.length - 1)}
              onChange={(e, newValue) => handleTabChange(newValue)}
              variant="scrollable"
              sx={{ padding: "0px", background: "#f5f5f5" }}
            >
              {filteredTabComponents.map((tab: any, index: any) => (
                <Tab
                  key={index}
                  label={tab?.label.replace(/_/g, " ")}
                  sx={{
                    fontWeight: "700",
                    fontSize: "12px",
                    minWidth: "50px",
                    padding: "4px 8px",
                  }}
                />
              ))}
            </Tabs>
          )}
          <Divider />
        </Box>

        {/* Only try to render if filteredTabComponents has items and activeTab is valid */}
        {filteredTabComponents.length > 0 &&
          activeTab < filteredTabComponents.length && (
            <>
              {filteredTabComponents[activeTab]?.subTabs ? (
                <Box>
                  {/* Only render subtabs if there are subtabs to display */}
                  {filteredTabComponents[activeTab]?.subTabs?.length > 0 && (
                    <Tabs
                      value={Math.min(
                        activeSubTab,
                        filteredTabComponents[activeTab].subTabs.length - 1
                      )}
                      onChange={(e, newValue) => handleSubTabChange(newValue)}
                      variant="scrollable"
                    >
                      {filteredTabComponents[activeTab].subTabs.map(
                        (subTab: any, index: any) => (
                          <Tab
                            key={index}
                            label={subTab?.label.replace(/_/g, " ")}
                            sx={{
                              fontWeight: "700",
                              fontSize: "12px",
                              minWidth: "50px",
                              padding: "2px 8px",
                            }}
                          />
                        )
                      )}
                    </Tabs>
                  )}
                  <Divider />
                  <Box p={1.5}>
                    {/* Use safeRenderComponent to safely render subtab components */}
                    {filteredTabComponents[activeTab]?.subTabs &&
                      activeSubTab <
                        filteredTabComponents[activeTab].subTabs.length &&
                      React.createElement(
                        safeRenderComponent(
                          filteredTabComponents[activeTab].subTabs[activeSubTab]
                        ),
                        {
                          onChange: handleTabChangeWithData,
                          data: fetchedData || null,
                          otherTabsData,
                          profile,
                          opdData,
                          handleSave: handleSave,
                        }
                      )}
                  </Box>
                </Box>
              ) : (
                <Box p={1}>
                  {/* Use safeRenderComponent to safely render tab components */}
                  {React.createElement(
                    safeRenderComponent(filteredTabComponents[activeTab]),
                    {
                      onChange: handleTabChangeWithData,
                      onhistorychange: handlehistorydata,
                      data: fetchedData || null, 
                      otherTabsData,
                      // formId,
                      // setFormId: setFormId,
                      // ctdresponseData,
                      profile,
                      onhistorychnagedata: knownData,
                      handleSaveObsData: handleSaveObsData,
                      opdData,
                      handleSave: handleSave,
                    }
                  )}
                </Box>
              )}
            </>
          )}

        {/* Show a message if no tabs are available */}
        {filteredTabComponents.length === 0 && (
          <Box p={2}>
            <Typography>
              No tabs available for the current admission type.
            </Typography>
          </Box>
        )}
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mt: 4,
          alignItems: "center",
        }}
      >
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 1, pl: 1, pb: 1 }}
        >
          <Button variant="outlined" onClick={() => navigate("/ipd-dashboard")}>
            Go To Dashboard
          </Button>
          {admissionType !== "Chemotherapy" && (
          <Box
            sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
          >
            <Box>
              <Typography
                variant="h6"
                sx={{ fontSize: "12px", fontWeight: "600" }}
              >
                Medical
              </Typography>
            </Box>
            {isSwitchDisabled ? (
              <Tooltip
                title="Patient is discharged, so you cannot change admission type."
                placement="top"
              >
                <span>
                  <Switch
                    checked={admissionType === "Surgical"}
                    onChange={handleSwitchChange}
                    disabled={isSwitchDisabled}
                  />
                </span>
              </Tooltip>
            ) : (
              <Switch
                checked={admissionType === "Surgical"}
                onChange={handleSwitchChange}
                disabled={isSwitchDisabled}
              />
            )}
            <Box>
              <Typography
                variant="h6"
                sx={{ fontSize: "12px", fontWeight: "600" }}
              >
                Surgical
              </Typography>
            </Box>
          </Box>
          )}
        </Box>
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 1, pr: 1, pb: 1 }}
        >
          <Tooltip title="Ctrl + Backspace" arrow placement="top">
            <Button
              size="small"
              variant="outlined"
              ref={back}
              onClick={handleBack}
            >
              Back
            </Button>
          </Tooltip>
          <Tooltip title="Escape" arrow placement="top">
            <Button
              size="small"
              variant="outlined"
              ref={saveAndExit}
              onClick={() => handleSave(true)}
            >
              {loading ? (
                <CircularProgress sx={{ color: "#fff" }} size={24} />
              ) : (
                "Save & Exit"
              )}
            </Button>
          </Tooltip>
          <Tooltip title="Ctrl + s" arrow placement="top">
            <Button
              size="small"
              ref={save}
              variant="outlined"
              onClick={() => handleSave(false)}
            >
              {loading ? (
                <CircularProgress sx={{ color: "#fff" }} size={24} />
              ) : (
                "Save"
              )}
            </Button>
          </Tooltip>
          {activeTab < filteredTabComponents?.length - 1 && (
            <Tooltip title="Shift + Enter" arrow placement="top">
              <Button
                size="small"
                variant="contained"
                ref={saveAndNext}
                onClick={handleNext}
              >
                {loading ? (
                  <CircularProgress sx={{ color: "#fff" }} size={24} />
                ) : (
                  "Save & Next"
                )}
              </Button>
            </Tooltip>
          )}
        </Box>
      </Box>

      <Dialog
        open={openDialog}
        onClose={handleCancelChange}
        aria-labelledby="confirmation-dialog-title"
        aria-describedby="confirmation-dialog-description"
      >
        <DialogTitle id="confirmation-dialog-title">
          Confirm Admission Type Change
        </DialogTitle>
        <DialogContent>
          <Typography id="confirmation-dialog-description">
            Are you sure you want to change the admission type from{" "}
            <strong>{admissionType}</strong> to{" "}
            <strong>{newAdmissionType}</strong>?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelChange} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmChange} color="primary" autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default TabbedForm;
